import { Button, Input } from 'antd';
import { CheckOutlined, CloseOutlined, EditFilled, EditOutlined } from '@ant-design/icons';
import { useState } from 'react';
const EditableText = ({
  value,
  onChange,
  style
}) => {
  const [editMode, setEditMode] = useState(false);
  const [inputText, setInputText] = useState(value);
  return editMode ? <span>
      {' '}
      <Input.Group compact>
        <Input style={{
        width: '75%'
      }} value={inputText} onChange={e => setInputText(e.target.value)} onPressEnter={() => {
        onChange(inputText);
        setEditMode(false);
      }} />
        <Button icon={<CheckOutlined />} type="primary" onClick={() => {
        onChange(inputText);
        setEditMode(false);
      }} />
        <Button icon={<CloseOutlined />} type="primary" danger onClick={() => {
        setInputText(value);
        setEditMode(false);
      }} />
      </Input.Group>
    </span> : <span>
      {value}{' '}
      <Button onClick={() => {
      setInputText(value);
      setEditMode(true);
    }} icon={<EditOutlined />} type="text" style={style} size="small" />{' '}
    </span>;
};
export default EditableText;